module.exports = __webpack_public_path__ + "img/homePageImg01.7c845213.png";